function loadEvoPaymentsScript() {
    return new Promise((resolve, reject) => {
      const existingScript = document.getElementById('evo-payments-script');
  
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = "https://evopaymentsmexico.gateway.mastercard.com/static/checkout/checkout.min.js";
        script.id = 'evo-payments-script';
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          console.error("Error loading Evo Payments script.");
          reject();
        };
        document.body.appendChild(script);
      } else {
        resolve(); // Script is already loaded
      }
    });
  }
  
  export default loadEvoPaymentsScript;
  